import { render, staticRenderFns } from "./BatchManager.vue?vue&type=template&id=c04f2038&"
import script from "./BatchManager.vue?vue&type=script&lang=js&"
export * from "./BatchManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports